import { createContext, useContext } from "react";

// Asks the Drafting chat open a question, as his sections do; null outside
// the assistant's pane.
export const AskContext = createContext<{
  onAsk(question: string): void;
  disabled: boolean;
} | null>(null);

export const useAsk = () => useContext(AskContext);
